import lobola1 from './/lobola1.jpeg';
import lobola2 from './/lobola2.jpeg';
import lobola3 from './/lobola3.jpeg';
import lobola4 from './/lobola4.jpg';
import lobola5 from './/Lobola5.jpg';
import lobola6 from './/Lobola6.jpg';
import lobola7 from './/Lobola7.jpg';
import lobola8 from './/Lobola8.jpg';
import lobola9 from './/Lobola9.jpg';
import lobola10 from './/Lobola10.jpg';
import lobola11 from './/Lobola11.jpg';
import lobola12 from './/Lobola12.jpg';
import lobola13 from './/Lobola13.jpg';
import lobola14 from './/Lobola14.jpg';
import lobola15 from './/Lobola15.jpg';
import lobola16 from './/Lobola16.jpg';
import lobola17 from './/Lobola17.jpg';
import lobola18 from './/Lobola18.png';
import lobola19 from './/Lobola19.jpg';
import lobola20 from './/Lobola20.jpg';
import lobola21 from './/Lobola21.jpg';
import lobola22 from './/Lobola22.jpg';
import lobola23 from './/Lobola23.jpg';
import lobola24 from './/Lobola24.jpg';
import lobola25 from './/Lobola25.jpg';
import lobola26 from './/Lobola26.jpg';
import lobola27 from './/Lobola27.jpg';

export interface CustomImage {
  src: string;
  original: string;
  width: number;
  height: number;
}

export const images: CustomImage[] = [
    {
        src: lobola1,
        original: lobola1,
        width: 200,
        height: 200,
      },
      {
        src: lobola2,
        original: lobola2,
        width: 200,
        height: 212,
      },
      {
        src: lobola3,
        original: lobola3,
        width: 320,
        height: 212,
      },
      {
        src: lobola4,
        original: lobola4,
        width: 200,
        height: 213,
      },
      {
        src: lobola5,
        original: lobola5,
        width: 320,
        height: 183,
      },
      {
        src: lobola6,
        original: lobola6,
        width: 300,
        height: 320,
      },
      {
        src: lobola7,
        original: lobola7,
        width: 200,
        height: 200,
      },
      {
        src: lobola8,
        original: lobola8,
        width: 150,
        height: 148,
      },
      {
        src: lobola9,
        original: lobola9,
        width: 320,
        height: 213,
      },
      {
        src: lobola10,
        original: lobola10,
        width: 400,
        height: 320,
      },
      {
        src: lobola11,
        original: lobola11,
        width: 180,
        height: 113,
      },
      {
        src: lobola12,
        original: lobola12,
        width: 313,
        height: 320,
      },
      {
        src: lobola13,
        original: lobola13,
        width: 320,
        height: 213,
      },
      {
        src: lobola14,
        original: lobola14,
        width: 320,
        height: 194,
      },
      {
        src: lobola15,
        original: lobola15,
        width: 320,
        height: 213,
      },
      {
        src: lobola16,
        original: lobola16,
        width: 271,
        height: 320,
      },
      {
        src: lobola17,
        original: lobola17,
        width: 271,
        height: 320,
      },
      {
        src: lobola18,
        original: lobola18,
        width: 271,
        height: 320,
      },
      {
        src: lobola19,
        original: lobola19,
        width: 271,
        height: 320,
      },
      {
        src: lobola20,
        original: lobola20,
        width: 271,
        height: 320,
      },
      {
        src: lobola21,
        original: lobola21,
        width: 271,
        height: 320,
      },
      {
        src: lobola22,
        original: lobola22,
        width: 271,
        height: 320,
      },
      {
        src: lobola23,
        original: lobola23,
        width: 271,
        height: 320,
      },
      {
        src: lobola24,
        original: lobola24,
        width: 271,
        height: 320,
      },
      {
        src: lobola25,
        original: lobola25,
        width: 271,
        height: 320,
      },
      {
        src: lobola26,
        original: lobola26,
        width: 271,
        height: 320,
      },
      {
        src: lobola27,
        original: lobola27,
        width: 271,
        height: 320,
      },
  
  
];